// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import ReactTooltip from "react-tooltip";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
import { RelayProp } from "react-relay";
// event-summary-external-attendees
import { eventSummaryExternalAttendeesFragments } from "./EventSummaryExternalAttendees.gql";
import { EventSummaryRow as s } from "./EventSummary.styles";
import { IReduxState } from "@reducers/root.reducer";
// util
import { niceAttendeeNamesWithCarryover } from "@util/event.util";
// material-ui
import { PersonAdd } from "@material-ui/icons";

export interface IContainer {
  color?: string;
  attendees: ISchema.IAttendee[];
  persons: ISchema.IPerson[];
  org: ISchema.IOrg;
}

export interface IProps extends IContainer {
  relay: RelayProp;
}

class EventSummaryExternalAttendeesCmpt extends React.Component<IProps, IContainer> {
  constructor(props: IProps) {
    super(props);
  }

  private getTooltipContent = (carryoverNames: string[]) => {
    return (
      <React.Fragment>
        {carryoverNames.slice(0, 4).map((name, i) => (
          <div key={`carryover-${i}`}>{name}</div>
        ))}
        {carryoverNames.length > 4 ? <div>+{carryoverNames.length - 4} more</div> : null}
      </React.Fragment>
    );
  };

  public render() {
    const { color } = this.props;

    const { niceNameArray, carryover } = niceAttendeeNamesWithCarryover(
      this.props.attendees,
      this.props.persons,
      15,
    );

    if (!niceNameArray.length) {
      return <span />;
    }

    let attendeesSentence;
    let maybeTooltip;
    let maybeCarryover;

    // cut out the + others text to be used for tooltip
    // set our maybes
    if (carryover.length) {
      attendeesSentence = niceNameArray.slice(0, niceNameArray.length - 1).join("");

      const randomToolTipId = Math.random();
      maybeCarryover = (
        <span data-for={`tooltip-external-attendees-carryover-${randomToolTipId}`} data-tip>
          {niceNameArray[niceNameArray.length - 1]}
        </span>
      );

      maybeTooltip = (
        <ReactTooltip
          id={`tooltip-external-attendees-carryover-${randomToolTipId}`}
          getContent={() => this.getTooltipContent(carryover)}
        />
      );
    } else {
      attendeesSentence = niceNameArray.join("");
    }

    return (
      <div style={{ ...s.container, alignItems: "flex-start" }}>
        <PersonAdd style={{ ...s.icon, color }} htmlColor={color || s.icon.color} />
        <div style={{ ...s.text, color, lineHeight: 1.5 }}>
          <span>External attendee: </span>{" "}
          <span style={{ fontWeight: "bold" }}>
            {attendeesSentence}
            <span style={{ textDecoration: "underline", textDecorationStyle: "dashed" }}>
              {maybeCarryover}
            </span>
          </span>
          {maybeTooltip}
        </div>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const EventSummaryExternalAttendeesRedux = connect(
  mapStateToProps,
  {},
)(EventSummaryExternalAttendeesCmpt);

//////////////////
// RELAY
//////////////////
export const EventSummaryExternalAttendees = createFragmentContainer<IContainer>(
  EventSummaryExternalAttendeesRedux,
  eventSummaryExternalAttendeesFragments,
);
